import useWindowSize from 'core-lib/hooks/useWindowResize';
import CalculatorWidget from 'src/modules/emiCalculator/components/CalculatorWidget';
import { BackButton, Modal } from 'ui';
import s from './EmiCalculator.module.scss';

export const EmiCalculator = ({ show, onClose, price }: { show: boolean, onClose: () => void, price: number }) => {
  const { width, height } = useWindowSize();
  return (
    <>
      {width > 800 ?
        <Modal
          show={show}
          isWeb
          head={{
            show: false,
            title: 'Emi calculator',
            onClose: onClose,
          }}
          closeOnClickOutside
          noPadding
          animation={{ type: 'fadeAfter', timeout: 's' }}
          variant="fullScreenPopup"
          rootStyle={{
            zIndex: 10,
          }}
          customeBodyStyle={{
            minWidth: '1000px',
            minHeight: '676px',
          }}
        >
          <div className={s.root}>
            <div className={s.back_btn}>
              <BackButton onBack={onClose} type="cross" />
            </div>
            <CalculatorWidget amount={price} tenure={7} />
          </div>
        </Modal> :
        <Modal
          show={show}
          isWeb
          head={{
            show: true,
            title: 'Emi Calculator',
            onClose: onClose,
          }}
          noPadding
          animation={{ type: 'fadeAfter', timeout: 's' }}
          variant="page"
          rootStyle={{
            zIndex: 10,
          }}
        >
          <div className={s.root}>
            <CalculatorWidget amount={price} tenure={7} />
          </div>
        </Modal>}
    </>

  );
};
